import { Navigate, useLocation, useSearchParams } from "react-router-dom";

export default function AdminRoute({ element }) {
  const location = useLocation();  
  return localStorage.getItem('tokenme') && localStorage.getItem('tokenme') === `4b9d9232b9327346a7ded4a505db2f97` ? (
    element
  ) : (
    <Navigate to="/auth/login" state={{ from: location }} replace />
  );
}